import { render } from "./layanan_selengkapnya.vue?vue&type=template&id=0949ba7a"
import script from "./layanan_selengkapnya.vue?vue&type=script&lang=js"
export * from "./layanan_selengkapnya.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__